import styled from "styled-components";
import { Modal } from "antd";

export const HistoryModalStyled = styled(Modal)`
  .ant-modal-content {
    background-color: #0c0d22;

    .ant-modal-close {
      display: none;
    }

    .anticon-left {
      color: #fff;
      font-size: 24px;
      &:hover {
        color: #156df2;
      }
    }
  }

  .filter {
    background-color: #2e2f55;
    border-radius: 10px;
    padding: 10px;
    margin-bottom: 10px;

    .ant-picker {
      background-color: #0c0d22;
      border-color: #0c0d22;
      color: #fff;
      border-radius: 5px;

      .ant-picker-input {
        color: #fff;
      }

      .ant-picker-separator {
        color: #fff;
      }

      .ant-picker-suffix {
        color: #fff;
        font-size: 18px;
      }
    }

    .ant-select {
      background-color: #156df2;
      border-color: #156df2;
      color: #fff;
      border-radius: 5px;

      .ant-select-selector {
        background-color: #156df2;
        border-color: #156df2;
        color: #fff;
        border-radius: 5px;
      }

      .ant-select-arrow {
        color: #fff;
      }
    }
  }

  .history-reward-table {
    .ant-table-header {
      background-color: #0c0d22;

      table {
        background-color: #0c0d22;
        border-collapse: collapse;
        .ant-table-thead {
          .ant-table-cell {
            background-color: #2e2f55;
            border-bottom: none;
            color: #fff;

            &:first-child {
              border-top-left-radius: 10px;
            }

            &:last-child {
              border-top-right-radius: 20px;
              box-shadow: none;
            }
          }
        }
      }
    }

    .ant-table-body {
      table {
        .ant-table-cell {
          border-bottom: 1px solid #ffffff17;
          color: #fff;
          background-color: #0c0d22;

          &:hover {
            background-color: #0c0d22;
          }

          &.ant-table-cell-row-hover {
            background-color: #0c0d22;
          }
        }
      }

      .ant-empty {
        .ant-empty-description {
          color: #fff;
        }
      }
    }

    .ant-pagination {
      .ant-pagination-disabled {
        .ant-pagination-item-link {
          background-color: #323b49;
          border-color: #323b49;
          color: #a0aec0;
        }
      }
      .ant-pagination-item-link {
        background-color: #2b6ae6;
        border-color: #2b6ae6;
        color: #fff;
        border-radius: 6px;
      }

      .ant-pagination-item {
        background-color: rgb(67, 144, 233);
        border-color: rgb(67, 144, 233);
        border-radius: 6px;

        a {
          color: #fff;
        }

        &.ant-pagination-item-active {
          background-color: rgb(5, 64, 204);
          border-color: rgb(5, 64, 204);
          a {
            color: #fff;
            font-weight: 600;
          }
        }
      }
    }

    ::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-track {
      background: #0c0d22;
    }

    ::-webkit-scrollbar-thumb {
      background: #156df2;
      border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: #1259c7;
    }
  }
`;

export const RewardNameStyled = styled.div`
  display: flex;
  align-items: center;

  .reward-name {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const StyledPopupContent = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.09);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.5);
`;
